import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '@/services/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {

          navigate('/admin/login');
          return;
        }

        // Exchange session_id for local session
        const response = await api.post('/api/auth/google', { session_id: sessionId });

        if (response.data.success) {
          // Clear the hash from URL and navigate to dashboard
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/admin/dashboard', { 
            state: { user: response.data.user },
            replace: true 
          });
        } else {
          throw new Error('Authentication failed');
        }
      } catch (error) {
        navigate('/admin/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#001A47] via-[#002B6B] to-[#001A47] flex items-center justify-center">
      <div className="text-center text-white">
        <Loader2 className="h-12 w-12 animate-spin mx-auto mb-4 text-[#039fff]" />
        <h2 className="text-xl font-semibold mb-2">Authenticating...</h2>
        <p className="text-gray-400">Please wait while we complete your sign-in</p>
      </div>
    </div>
  );
};

export default AuthCallback;
